<template>
  <div :style="noCoincideHistorico()?'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;':''">
    <div v-if="type == 'badge'"  class="item-content item-input item-input-with-value">
      <div class="item-inner">
        <div v-if="label" class="item-title item-label item-floating-label">
          {{label}}
        </div>
        <slot name="label"></slot>
        <div class="item-input-wrap">
          <r-badge :text="text" :color="color"></r-badge>
        </div>
        <f7-link
          v-if="getShowDecorationLink()"
          class="input-suffix-btn r-input-little r-input-top"
          :icon-f7="decorationConfig.icon"
          :color="decorationConfig.color"
          v-tooltip="decorationConfig.tooltip"
          @click="decorationConfig.action()"
        ></f7-link>
        <f7-link
          v-if="viewHistory && hasHistory && Utils.posterior2Dic2024(form.dateRef)"
          class="input-suffix-btn r-input-little r-input-top history-link"
          :class="{'color-historico-ultimo-online': hayCambiosOnline()}"
          :icon-f7="'archivebox'"
          v-tooltip="'Historico de valores'"
          @click="showHistory"
        ></f7-link>
        <span v-if="htmlError" v-html="htmlError()" @click.prevent="mostrarError()" style="z-index: 100;"></span>
      </div>
    </div>
    <div v-else-if="type == 'check' && !simple" class="item-content item-input item-input-with-value">
      <div class="item-inner">
        <div v-if="label" class="item-title item-label item-floating-label">
          {{label}}
        </div>
        <slot name="label"></slot>
        <div class="item-input-wrap">
          <f7-link
            v-if="viewHistory && hasHistory && Utils.posterior2Dic2024(form.dateRef)"
            class="input-suffix-btn r-input-little r-input-top history-link"
          :class="{'color-historico-ultimo-online': hayCambiosOnline()}"
            :icon-f7="'archivebox'"
            v-tooltip="'Historico de valores'"
            @click="showHistory"
          ></f7-link>
          <f7-toggle 
            class="item-input-wrap"
            :checked="getValue()"
            @change="setValue($event.target.checked, $event.target, true)"
            :disabled="form.username == 'NOID' ? form.readonly : (overrideReadonly? readonly : readonly || form.readonly)"
            v-on="$listeners"
          ></f7-toggle>
        </div>
        <span v-if="htmlError" v-html="htmlError()" @click.prevent="mostrarError()" style="z-index: 100;"></span>
      </div>
      <slot name="content"></slot>
    </div>
    <div v-else-if="type == 'check'">
      <f7-list>
        <f7-link
          v-if="viewHistory && hasHistory && Utils.posterior2Dic2024(form.dateRef)"
          class="input-suffix-btn r-input-little r-input-top history-link"
          :class="{'color-historico-ultimo-online': hayCambiosOnline()}"
          :icon-f7="'archivebox'"
          v-tooltip="'Historico de valores'"
          @click="showHistory"
        ></f7-link>
        <f7-list-item
          checkbox
          v-on="$listeners"
          :disabled="form.username == 'NOID' ? form.readonly : (overrideReadonly? readonly : readonly || form.readonly)"
          :title="label"
          :checked="getValue()"
          @change="setValue($event.target.checked, $event.target, true)"
        ></f7-list-item>
      </f7-list>
      <span v-if="htmlError" v-html="htmlError()" @click.prevent="mostrarError()" style="z-index: 100;"></span>
      <slot name="content"></slot>
    </div>
    <div v-else-if="type == 'checks'" class="item-content item-input item-input-with-value">
      <div class="item-inner item-checks">
        <div v-if="label" class="item-title item-label item-label-up item-floating-label">
          {{label}}
        </div>
        <slot name="label"></slot>
        <div class="item-input-wrap">
          <f7-list>
            <f7-list-item 
              v-for="(itm, idx) in dbItems"
              :key="name + 'check-' + idx"
              @change="setValue($event.target.checked, $event.target, true)"
              :checked="isCheckedChecks(itm.value)"
              checkbox 
              :name="name"
              :title="itm.name"
              :value="itm.value"
            ></f7-list-item>
            <f7-link
              v-if="viewHistory && hasHistory && Utils.posterior2Dic2024(form.dateRef)"
              class="input-suffix-btn r-input-little r-input-top history-link"
              :class="{'color-historico-ultimo-online': hayCambiosOnline()}"
              :icon-f7="'archivebox'"
              v-tooltip="'Historico de valores'"
              @click="showHistory"
            ></f7-link>
          </f7-list>
          <span v-if="htmlError" v-html="htmlError()" @click.prevent="mostrarError()" style="z-index: 100;"></span>
        </div>
      </div>
      <slot name="content"></slot>
    </div>
    <!-- @change="type == 'date' || type == 'datetime-local' ? undefined : setValue($event.target.value, $event.target)" -->
    <f7-list-input
      v-else
      :value="getValue()"
      v-bind="{...$attrs,...$props}"
      autocomplete="no"
      @input="setValue($event.target.value, $event.target)"
      @change="type == 'date' || type == 'datetime-local' ? null : setValue($event.target.value, $event.target, true)"
      @calendar:change="type == 'date' || type == 'datetime-local' ? null : setValue($event, 'calendar')"
      v-on="$listeners"
      :error-message-force="!!form.errors[name] || !!errorForce"
      :error-message="form.errors[name] || errorForce"
      :readonly="form.username == 'NOID' ? form.readonly : (overrideReadonly ? readonly : readonly || form.readonly)"
      :class="{readonly:form.username == 'NOID' ? form.readonly : (overrideReadonly ? readonly : (readonly || form.readonly)), inputDate:type == 'date' || type == 'datetime-local', inputDate:allMayus?'allMayus':'','no-list-decorator':!listDecorator}"
      v-tooltip="viewTooltip ? (labelTooltip ? labelTooltip +':<br>' : (label ? label + ':<br>' : '')) + (getValue() ? (type == 'datepicker' || type == 'date' || type == 'datetime-local' ? dateToString(getValue()) : getValue()) : '') : ''"
      :clear-button="type == 'date' || type == 'datetime-local' ? false : (!(overrideReadonly ? readonly : readonly || form.readonly) && clearButton)"
      @input:clear="setValue(null)"
      :type="type == 'integer' ? 'number' : type"
      :resizable="resizable"
    >
      <slot name="label" slot="label"></slot>
      <slot name="info" slot="info"></slot>
      <slot></slot>
      <slot name="media" slot="media"></slot>
      <slot name="content-start" slot="content-start"></slot>
      <slot name="content" slot="content"></slot>
      <slot name="inner-end" slot="inner-end">
        <f7-link
          v-if="getShowDecorationLink()"
          class="input-suffix-btn r-input-little r-input-top"
          :icon-f7="decorationConfig.icon"
          :color="decorationConfig.color"
          v-tooltip="decorationConfig.tooltip"
          @click="decorationConfig.action()"
        ></f7-link>
        <f7-link
          v-if="viewHistory && hasHistory && Utils.posterior2Dic2024(form.dateRef)"
          class="input-suffix-btn r-input-little r-input-top history-link"
          :class="{'color-historico-ultimo-online': hayCambiosOnline()}"
          :icon-f7="'archivebox'"
          :style="'right: -10px; top: '+(['textarea','punto'].includes(type)?'50%;':'')"
          v-tooltip="'Historico de valores'"
          @click="showHistory"
        ></f7-link>
      </slot>
      <slot name="content-end" slot="content-end">
      </slot>
      <slot name="root-end" slot="root-end"></slot>
      <slot name="inner-start" slot="root-end"></slot>
      <slot name="error-message" slot="error-message"></slot>
    </f7-list-input>
    <span v-if="htmlError" v-tooltip="tooltipError" v-html="htmlError()" @click.prevent="mostrarError()" style="z-index: 100;"></span>

    <f7-popover class="history-popover" :closeByOutsideClick="form.username != 'NOID'" :closeByBackdropClick="form.username != 'NOID'" :backdrop="true" closeOnEscape ref="popoverHistory" style="width: auto; max-width: 90%;">
      <div style="min-width: 250px;">
        <f7-navbar :title="$t('Historico de cambios')">
          <f7-nav-right>
            <f7-link popover-close icon-f7="multiply"></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <div class="scrollable-content">
            <table>
              <thead>
                <tr style="background-color: #22355b;color: #FFF;">
                  <th>Valor</th>
                  <th>Fecha</th>
                  <th>Usuario</th>
                </tr>
              </thead>
              <tbody  v-if="form.username != 'NOID'">
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">{{getStrValueHistory(itm.valor)}}</td>
                  <td class="datos-auditoria">{{itm.date}}</td>
                  <td class="datos-auditoria">{{itm.username || ' - '}}</td>
                </tr>
              </tbody>
              <tbody  v-else>
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">
                    <div v-if="type == 'check' || type == 'checks'">
                      <f7-toggle 
                        class="item-input-wrap"
                        :checked="getValueHistory(itm.valor)"
                        @input="setValueHistory($event.target.checked, $event.target, true, false, itm)"
                        @change="type == 'date' || type == 'datetime-local' ? null : setValueHistory($event.target.checked, $event.target, true, false, itm)"
                        :disabled="form.username == 'NOID' ? form.readonly : (overrideReadonly? readonly : readonly || form.readonly)"
                      ></f7-toggle>
                    </div>
                    <div v-else>
                      <f7-list-input
                        :value="getValueHistory(itm.valor)"
                        autocomplete="false"
                        @change="setValueHistory($event[0]||$event.target.value, $event.target, true, false, itm)"
                        @calendar:change="setValueHistory($event[0]||$event.target.value, type == 'datepicker'?'calendar':$event.target, true, false, itm)"
                        :type="type == 'integer' ? 'number' : type"
                        :resizable="resizable"
                        :readonly="false"
                      ></f7-list-input>
                    </div>
                  </td>
                  <td class="datos-auditoria">
                    <!-- {{itm.date}} -->
                    <f7-list-input
                      :value="getDateHistory(itm.date)"
                      :type="'datetime-local'"
                      @input="itm.date = $event.target.value"
                      @change="itm.date = $event.target.value"
                      @calendar:change="itm.date = $event.target.value"
                      v-on="$listeners"
                    ></f7-list-input>
                  </td>
                  <td class="datos-auditoria">
                    <f7-list-input
                      :value="itm.username"
                      type="text"
                      @change="itm.username = $event.target.value"
                    />
                  </td>
                  <td class="datos-opciones">
                    <f7-link @click="updateHistory(itm)" icon-f7="floppy_disk"></f7-link>
                    <f7-link @click="deleteFieldFromHistory(itm)" icon-f7="trash" color="red"></f7-link>
                  </td>
                  <!-- <td>{{ itm.id }}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </f7-block>
      </div>
    </f7-popover>
  </div>
</template>
<style scoped>
</style>
<script>
import DateUtils from "./../js/DateUtils";
import EntityUtils from "./../js/EntityUtils";
import Utils from "./../js/Utils";
import rBadge from './rBadge.vue';
import JSONPath from 'jsonpath';

export default {
  components: { rBadge },
  data() {
    return {
      self: this,
      target: process.env.TARGET,
      history: [],
      DateUtils,
      EntityUtils,
      Utils,
      JSONPath,
    };
  },
  props: {
    name: {
      required: true,
      type: String
    },
    altername: {
      required: false,
      type: String,
      default: ''
    },
    simple: {
      type: Boolean,
      default: false
    },
    resizable: {
      type: Boolean,
      default: false
    },
    allMayus: {
      type: Boolean,
      default: false
    },
    form: {
      required: false,
      type: Object,
      default: function() {
        return {};
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    overrideReadonly: {
      type: Boolean,
      default: false
    },
    viewTooltip: {
      type: Boolean,
      default: true
    },
    viewHistory: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      default: ""
    },
    labelTooltip: {
      type: String,
      default: ""
    },
    formatDate: {
      type: String,
      default: "DD/MM/YYYY"
    },
    clearButton: {
      type: Boolean,
      default: true
    },
    validation: {
      type: Object
    },
    dbItems: {
      type: Array
    },
    saveAsString: {
      type: Boolean,
      default: false
    },
    listDecorator: {
      type: Boolean,
      default: true
    },
    text: {
      type: String
    },
    errorForce: {
      type: String
    },
    color: {
      type: String
    },
    decorationConfig: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasHistory: function () {
      return this.form?.history && this.form?.history[this.name];
    },
  },
  methods: {
    mostrarError: function() {
      const self = this;
      var app = self.$f7;
      let expediente = self.form.formData;
      let htmlError = expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name))
                .flatMap(e => e.errores)
                .map(e => '<div class="regla regla-'+e.tipoRegla+'" ><span style="color: black;">'+e.nombre + '.- </span>' + e.error+'</div>').join(' ');
      let msg = '<div>' + htmlError + '</div>';
      app.dialog.alert(msg,'Errores del campo');
    },
    htmlError: function() {
      const self = this;
      let expediente = self.form.formData;
      let msgError;
      if(expediente && expediente.listErrorsForLabel && expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name)).length)
      {
        msgError = EntityUtils.formateoError(expediente, self.altername || self.name);
      }
      return msgError;
    },
    tooltipError: function() {
      const self = this;
      let expediente = self.form.formData;
      let msgError;
      if(expediente && expediente.listErrorsForLabel && expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name)).length)
      {
        msgError = EntityUtils.tooltipError(expediente, (self.altername ||self.name));
      }
      return msgError;
    },
    /**
     * Extrae el array de valores seleccionados desde un string concatenado,
     * cotejando con las opciones disponibles para manejar opciones que contengan comas.
     * 
     * @param {string} concatenatedString - String con valores concatenados por comas
     * @param {Array} options - Array de opciones disponibles (dbItems con name/value)
     * @returns {Array} - Array con los valores seleccionados
     */
    extractChecksFromString: function(concatenatedString, options) {
      if (!concatenatedString || !options || !options.length) {
        return [];
      }
      
      // Extraer solo los valores de las opciones disponibles
      const availableValues = options.map(opt => opt.value || opt.name || opt);
      
      // Ordenar las opciones por longitud descendente para priorizar las más largas
      // (evita que "Opción A" se detecte antes que "Opción A, con coma")
      const sortedValues = [...availableValues].sort((a, b) => b.length - a.length);
      
      const selected = [];
      let remaining = concatenatedString;
      
      // Intentar encontrar cada opción en el string
      for (const value of sortedValues) {
        // Buscar el valor con diferentes patrones posibles
        const patterns = [
          new RegExp(`^${this.escapeRegExp(value)},`, 'g'),  // Al principio seguido de coma
          new RegExp(`,${this.escapeRegExp(value)},`, 'g'),  // En medio con comas
          new RegExp(`,${this.escapeRegExp(value)}$`, 'g'),  // Al final precedido de coma
          new RegExp(`^${this.escapeRegExp(value)}$`, 'g')   // Único valor
        ];
        
        for (const pattern of patterns) {
          if (pattern.test(remaining)) {
            selected.push(value);
            // Eliminar el valor encontrado del string para evitar duplicados
            remaining = remaining.replace(pattern, (match) => {
              // Reemplazar manteniendo la estructura de comas
              if (match.startsWith(',') && match.endsWith(',')) return ',';
              if (match.startsWith(',') || match.endsWith(',')) return '';
              return '';
            });
            break;
          }
        }
      }
      
      return selected;
    },
    /**
     * Escapa caracteres especiales de RegExp
     */
    escapeRegExp: function(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    isCheckedChecks: function (val) {
      const self = this;
      const arr = self.getValue();
      if (arr && arr.length && (arr.indexOf(val) > -1)) {
        return true;
      }
      return false;
    },
    dateToString: function(date) {
      const self = this;
      
      if (!date.length) {
        return "";
      } else if( typeof date == 'string' && (/^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}:\d{2}$/i.test(date) || /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}$/i.test(date))) {
        date = new Date(date);
        return DateUtils.dateFormat(date, self.formatDate);
      }
      return DateUtils.dateFormat(date[0], self.formatDate);
    },
    getValue: function(historico = false) {
      const self = this;
      var namespaces = self.name.split(".");
      var context = historico ? self.form.history : self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        if (typeof context == "undefined" || context == null) context = {};
        context = context[namespaces[i]];
      }
      if (self.type == "checks") {
        if (context) {
          if (self.saveAsString) {
            // Usar función inteligente para extraer valores cuando las opciones pueden contener comas
            context = self.extractChecksFromString(context, self.dbItems);
          }
        } else {
          context = [];
        }
      } else if (self.type == "check") {
        context = context == "true" || context == true;
      } else if (self.type == "datepicker") {
        if (context) {
          var previousVal = context;
          if (typeof context == "string") {
            context = new Date(previousVal);
            if (isNaN(context.getTime())) {
              var dateParts = previousVal.split("/");
              // month is 0-based, that's why we need dataParts[1] - 1
              while (dateParts.length < 3) {
                dateParts.unshift(1);
              }
              context = new Date(dateParts[2], dateParts[1] - 1, + dateParts[0]); 
            }
          }
          context = [context];
        } else {
          context = [];
        }
      } else if (self.type == "date") {
        if (context) {
          context = DateUtils.dateFormat(context, 'YYYY-MM-DD');
        } 
      } else if (self.type == "datetime-local") {
        if (context) {
          context = DateUtils.dateFormat(context, 'YYYY-MM-DDTHH:mm');
        } 
      }
      return context;
    },
    showHistory: function(event) {
      const self = this;
      const rawHistory = self.form.history[self.name] || [];
      // excluimos entradas donde `valor` no venga informado en el documento `nuevo`
      // (collectChanges en rForm.vue siempre añade la clave `valor`, pero la deja a undefined
      // cuando el histórico solo refleja cambios en otros campos hermanos como erroresAuditoria)
      // Clonamos shallow cada item para que el formateo posterior (date, valorAnterior, ...)
      // no mute los objetos del histórico original.
      let entradas = rawHistory.filter(itm => itm && itm.valor !== undefined);
      // En modo NOID el histórico se edita y se borra entrada a entrada, así que allí lo mostramos
      // completo; para el resto colapsamos las ráfagas de valores repetidos consecutivos.
      if (self.form.username != 'NOID') {
        entradas = Utils.colapsaRafagasHistorico(entradas, valor => self.getStrValueHistory(valor));
      }
      self.history = entradas.map(itm => ({...itm}));
      // vamos a formatear los campos de fecha
      for (var i = 0; i < self.history.length; i++) {
        if(self.history[i].valor === undefined) {
          self.history[i].valor = '';
        }
        if(self.history[i].valorAnterior === undefined) {
          self.history[i].valorAnterior = '';
        }

        switch(self.type) {
          case 'check':
            // if(self.history[i].valor === true) {
            //   self.history[i].valor = 'Si';
            // } else if(self.history[i].valor === false) {
            //   self.history[i].valor = 'No';
            // }
            if(self.history[i].valorAnterior === true) {
              self.history[i].valorAnterior = 'Si';
            } else if(self.history[i].valorAnterior === false) {
              self.history[i].valorAnterior = 'No';
            }
            break;
          case 'date':
          case 'datetime-local':
          case 'datepicker':
            // self.history[i].valor = DateUtils.isDate(self.history[i].valor)?self.history[i].valor:(self.history[i].valor?DateUtils.dateFormat(self.history[i].valor, self.formatDate):'');
            self.history[i].valorAnterior = DateUtils.isDate(self.history[i].valorAnterior)?self.history[i].valorAnterior:(self.history[i].valorAnterior?DateUtils.dateFormat(self.history[i].valorAnterior, self.formatDate):'');
            break;
        }

        self.history[i].date = DateUtils.dateFormat(self.history[i].date, 'DD/MM/YYYY HH:mm');
        self.history[i].username = self.history[i].username || '-';
      }
      if(event.target) self.$refs.popoverHistory.open(event.target);
    },
    hayCambiosOnline: function () {
      const self = this;
      // Los propios campos de sesionesManuales definen la ventana temporal,
      // así que no tiene sentido marcarlos como "fuera de sesión".
      if (typeof self.name === 'string' && self.name.indexOf('sesionesManuales.') === 0) return false;
      let colorear = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            colorear = true;
            break;
          }
        }
      }
      if (!colorear) return false;
      let history = self.form.history ? self.form.history[self.name] : null;
      history = history ? [...history] : [];
      history = history.filter(itm => itm && itm.valor !== undefined);
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      if (!history.length) return false;
      const sesionesManuales = self.form.formData ? self.form.formData.sesionesManuales : null;
      return !Utils.fechaEnSesionesManuales(history[0].date, sesionesManuales);
    },
    noCoincideHistorico: function () {
      const self = this;
      // miramos si el usuario tiene rol ADMINISTRACION, ADMIN o DTYCAL 
      let nocoincide = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            nocoincide = true;
            break;
          }
        }
      }
      let history = self.form.history ? self.form.history[self.name] : null;
      // ahora ordenamos el historico por fecha y nos quedamos con el elemento mas reciente
      history = history?[...history] : [];
      history = history.filter(itm => itm && itm.valor !== undefined);
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      // miraremos si el valor del historico más reciente, coincide con el del componente y si no coincide, devolveremos true
      return nocoincide && history && history.length && self.getStrValueHistory(history[0].valor) != self.getStrValueHistory(self.getValue());
    },
    getStrValueHistory(valor) {
      const self = this;
      let val = valor;
      switch(self.type) {
        case 'check':
          if(val === true || val === 'true') {
            val = 'Si';
          } else if(val === false || val === 'false') {
            val = 'No';
          }
          break;
        case 'date':
        case 'datetime-local':
        case 'datepicker':
          val = DateUtils.isDate(val)?val:(val?DateUtils.dateFormat(val, self.formatDate):'');
          break;
        case 'text':
          if(!valor) {
            val = '';
          }
          break;
      }
      return val;
    },
    getDateHistory(valor) {
      const self = this;
      let val = valor;
      if (val) {
        // si es un string con formato DD/MM/YYYY HH:mm lo convertimos a un objeto Date
        if (typeof val == "string" && (/^\d{2}\/\d{2}\/\d{4}[\s]+\d{2}:\d{2}(:\d{2})?$/i.test(val) )) {
          var dateParts = val.split(" ");
          var datePart = dateParts[0].split("/");
          var timePart = dateParts[1].split(":");
          // month is 0-based, that's why we need dataParts[1] - 1
          while (datePart.length < 3) {
            datePart.unshift(1);
          }
          val = new Date(datePart[2], datePart[1] - 1, + datePart[0], timePart[0], timePart[1]);
        }
        // si es una fecha en formato YYYY-MM-DD o YYYY-MM-DDTHH:mm la convertimos a un objeto Date
        else if (typeof val == "string" && (/^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}:\d{2}$/i.test(val) || /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}$/i.test(val))) {
          val = new Date(val);
        }
        val = DateUtils.dateFormat(val, 'YYYY-MM-DDTHH:mm');
      }
      return val;
    },
    getValueHistory(valor) {
      const self = this;
      var context = valor;
      if (self.type == "checks") {
        if (context) {
          if (self.saveAsString) {
            context = context.split(",");
          }
        } else {
          context = [];
        }
      } else if (self.type == "check") {
        context = (context == "Si" || context == "true" || context == true);
      } else if (self.type == "datepicker") {
        if (context) {
          var previousVal = context;
          if (typeof context == "string") {
            context = new Date(previousVal);
            if (isNaN(context.getTime())) {
              var dateParts = previousVal.split("/");
              // month is 0-based, that's why we need dataParts[1] - 1
              while (dateParts.length < 3) {
                dateParts.unshift(1);
              }
              context = new Date(dateParts[2], dateParts[1] - 1, + dateParts[0]); 
            }
          }
          if (!Array.isArray(context)){
            context = [context];
          }
        } else {
          context = [];
        }
      } else if (self.type == "date") {
        if (context) {
          context = DateUtils.dateFormat(context, 'YYYY-MM-DD');
        } 
      } else if (self.type == "datetime-local") {
        if (context) {
          context = DateUtils.dateFormat(context, 'YYYY-MM-DDTHH:mm');
        } 
      }
      return context;
    },
    setValueHistory: function(val, a, desdeChange = false, extraDataEmit = false, itm) {
      const self = this;
      if (self.type == "select" && !val) {
        val = null;
      } else if (self.type == "datepicker") {
        if (typeof val != 'undefined' && val != null && (!a || a != "calendar")) {return;}
        else if (val) {
          val = Array.isArray(val) ? val[0] : val;
        }
      } else if (self.type == "date" || self.type == "datetime-local") {
        
        if (val) {
          val = new Date(val);
          //val = DateUtils.isDate(val)?val:(val?DateUtils.dateFormat(val, self.formatDate):'');
        }
      } else if (self.type == "number" || self.type == "integer") {
        if (typeof val != undefined && val != null && val != "" && !isNaN(val)) {
          val = parseFloat(val);
        } else if (typeof val != undefined && val != null && val != "") {
          if (val.indexOf(",") > -1) {
            val = val.replace(",", ".");
          }
          if (!isNaN(val)) {
            val = parseFloat(val);
          } else {
            val = "";
          }
        } else {
          val = "";
        }
        if (self.saveAsString) {
          val = val + '';
        }
      } else if (self.type == "checks") {
        var values = self.getValue();
        if (val) {
          values.push(a.value);
        } else {
          values.splice(values.indexOf(a.value), 1);
        }
        if (self.saveAsString) {
          val = "";
          if (values && values.length) {
            for (var i = 0; i < values.length; i++) {
              if (i > 0) {
                val = val + ",";
              }
              val = val + values[i];
            }
          }
        } else {
          val = values;
        }
      } else if (self.type == "check") {
        val = val === true || val === 'true' || val === 'Si';
      } else if (val != undefined && self.allMayus && desdeChange){
        val = val.toUpperCase();
      }

      if (val != undefined && val === '') {
        if (self.type != "number") {
          val = undefined;
        }
      }
      itm.valor = val;
    },
    updateHistory: function(itm) {
      const self = this;
      // buscamos la entrada del historico en form.historyBulk por el id
      let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
      if(historyBulk) {
        historyBulk.date = new Date(self.getDateHistory(itm.date));
        historyBulk.username = itm.username;
      }
      let namespaces = self.name.split(".");
      let context = historyBulk?.nuevo;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.$set(context, namespaces[i], itm.valor);
        } else if (context[namespaces[i]] == null) {
          self.$set(context, namespaces[i], {});
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
      context = itm.valor;
      // console.log("historyBulk", context);
      // ahora guardaremos el historico con su nuevo valor
      self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
        .then(function(res) {
          window.location.reload();
          self.$f7.dialog.alert("El historico se ha actualizado correctamente.");
        })
        .catch(function(error) {
          if(error.status && error.status == 404) {
            console.log("error 404 URL: " + error.url);
          } else {
            app.dialog.alert(error.message);
          }
        });
      self.$refs.popoverHistory.close();
    },
    deleteFieldFromHistory: function(itm) {
      const self = this;
      self.$f7.dialog.confirm(
              "La línea de historico se eliminará y no podrá ser recuperada. ¿Está seguro?",
              "Advertencia",
              () => {
                // el delete va a ser un update en el que hemos eliminado el campo del valor actual
                let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
                let namespaces = self.name.split(".");
                let context = historyBulk?.nuevo;
                let contextParent = historyBulk?.nuevo;
                for (var i = 0; i < namespaces.length; i++) {
                  if (i == namespaces.length - 1) {
                    self.$set(context, namespaces[i], itm.valor);
                  } else if (context[namespaces[i]] == null) {
                    self.$set(context, namespaces[i], {});
                  } else if (typeof context[namespaces[i]] == "undefined") {
                    let n = namespaces[i + 1];
                    if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
                      //Número entero positivo
                      self.$set(context, namespaces[i], []);
                    } else {
                      self.$set(context, namespaces[i], {});
                    }
                  }
                  contextParent = context;
                  context = context[namespaces[i]];
                }
                // eliminamos el objeto context del contextParent
                if (contextParent) {
                  delete contextParent[namespaces[namespaces.length - 1]];
                  itm = undefined;
                }
                // ahora guardaremos el historico con su nuevo valor
                self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
                  .then(function(res) {
                    window.location.reload();
                    self.$f7.dialog.alert("El historico se ha actualizado correctamente.");
                  })
                  .catch(function(error) {
                    if(error.status && error.status == 404) {
                      console.log("error 404 URL: " + error.url);
                    } else {
                      app.dialog.alert(error.message);
                    }
                  });
                self.$refs.popoverHistory.close();
              },
              () => {
                // Cancelar
              }
            );
      
    },
    setValue: function(val, a, desdeChange = false, extraDataEmit = false) {
      console.log("setValue", val, a, desdeChange, extraDataEmit);
      const self = this;
      if (self.type == "select" && !val) {
        val = null;
      } else if (self.type == "datepicker") {
        if (typeof val != 'undefined' && val != null && (!a || a != "calendar")) return;
        else if (val) {
          val = val[0];
          if (val) {
            var previousVal = self.getValue();
            if (previousVal[0]) {
              val.setHours(previousVal[0].getHours());
              val.setMinutes(previousVal[0].getMinutes());
            }
          }
        }
      } else if (self.type == "date" || self.type == "datetime-local") {
        
        if (val) {
          val = new Date(val);
        }
      } else if (self.type == "number" || self.type == "integer") {
        if (typeof val != undefined && val != null && val != "" && !isNaN(val)) {
          val = parseFloat(val);
        } else if (typeof val != undefined && val != null && val != "") {
          if (val.indexOf(",") > -1) {
            val = val.replace(",", ".");
          }
          if (!isNaN(val)) {
            val = parseFloat(val);
          } else {
            val = "";
          }
        } else {
          val = "";
        }
        if (self.saveAsString) {
          val = val + '';
        }
      } else if (self.type == "checks") {
        var values = self.getValue();
        if (val) {
          values.push(a.value);
        } else {
          values.splice(values.indexOf(a.value), 1);
        }
        if (self.saveAsString) {
          val = "";
          if (values && values.length) {
            for (var i = 0; i < values.length; i++) {
              if (i > 0) {
                val = val + ",";
              }
              val = val + values[i];
            }
          }
        } else {
          val = values;
        }
      } else if (self.type == "check" && self.saveAsString) {
        val = val + "";
      } else if (val != undefined && self.allMayus && desdeChange){
        val = val.toUpperCase();
      }

      if (val != undefined && val === '') {
        if (self.type != "number") {
          val = undefined;
        }
      }

      var namespaces = self.name.split(".");
      var context = self.form.formData;
      console.log("namespaces", namespaces)
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.$set(context, namespaces[i], val);
          self.$emit("change", val, self, extraDataEmit);
        } else if (context[namespaces[i]] == null) {
          self.$set(context, namespaces[i], {});
          self.$emit("change", {}, self, extraDataEmit);
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
            self.$emit("change", [], self, extraDataEmit);
          } else {
            self.$set(context, namespaces[i], {});
            self.$emit("change", {}, self, extraDataEmit);
          }
        }
        context = context[namespaces[i]];
      }
    },
    getShowDecorationLink: function() {
      const self = this;
      if (self.decorationConfig) {
        if (self.decorationConfig.showDecoration) {
          return self.decorationConfig.showDecoration()
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },
  created() {
    var self = this;
    self.$emit("created", self);
  },
  mounted() {
    var $ = this.$$;
    var $el = $(this.$el);
    var self = this;
    var actualVal = self.getValue();
    let extraDataEmit = {
      fromMounted: true
    };
    if (self.validation) {
      self.form.validateFields[self.name] = self.validation;
    }
    if (self.type == 'select') {
      if (!actualVal) {
        var selected = self.$options._renderChildren.filter(function(c){
          return c.data && c.data.attrs && c.data.attrs.selected != undefined
        });
        if (selected && selected.length > 0) {
          var value = selected[0].data.attrs.value;
          if (value && value != null && value != '') {
            self.setValue(selected[0].data.attrs.value, self, false, extraDataEmit);
          }
        } else {
          self.setValue(null, self, false, extraDataEmit);
        }
      }
    } else if (self.type == 'check') {
      if (!actualVal) {
        self.setValue(false, self, false, extraDataEmit);
      }
    }
    self.$emit("mounted", self);
    /*self
      .$$(this.$el)
      .find("select")
      .on("mousedown", function(e) {
        if (self.readonly || self.form.readonly) {
          e.preventDefault();
          this.blur();
          window.focus();
        }
      });*/
  },
  destroyed() {
    var self = this;
    if (self.validation) {
      delete self.form.validateFields[self.name];
    }
  }
};
</script>
<style scope>
a.input-suffix-btn.r-input-little {
  height: 100%;
  top: 0;
}
a.r-input-little i.f7-icons {
  font-size: 8pt;
}
a.r-input-top {
  margin-top: 0;
}
a.r-input-top i.f7-icons {
  vertical-align: top;
}
.no-list-decorator {
  list-style: none;
}
td.datos-valor div li {
  list-style-type: none;
}
td.datos-auditoria li {
  list-style-type: none;
}
</style>

<style>
input[type="date"]:not(:focus):in-range::-webkit-datetime-edit-year-field,
input[type="date"]:not(:focus):in-range::-webkit-datetime-edit-month-field,
input[type="date"]:not(:focus):in-range::-webkit-datetime-edit-day-field,
input[type="date"]:not(:focus):in-range::-webkit-datetime-edit-text {
  color: transparent;
}
.readonly input,
.readonly select {
  pointer-events: none;
}

.item-checks .list {
  max-height: 170px;
  overflow: auto;
}
input[type="number"] + .input-clear-button, select + .input-clear-button{
  right: 20px;
}
span.input-clear-button {
  right: 2px;
  width: 14px;
  height: 14px;
}
</style>
